<script>
  export let label;
</script>

<li class="recovery-detail">
  <strong class="label">{label}</strong>
  <div class="detail">
    <slot/>
  </div>
</li>

<style>
  .recovery-detail {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
  }

  .label {
    width: auto;
  }

  .detail {
    width: 65%;
  }
</style>